var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',{staticClass:"LoginView",attrs:{"type":"signin"}},[_c('FormLogo',{attrs:{"slot":"logo"},slot:"logo"}),_c('FormSignin',{attrs:{"slot":"signin"},slot:"signin"}),_c('PageContent',{attrs:{"slot":"content"},slot:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }